import { useDossierStore } from "@/store/useDossierStore";
import { mutators, queries } from "@loanlink-nl/zero";
import type { MaybeRefOrGetter } from "vue";
import { ref, computed, toValue } from "vue";
import { useQuery, useZero } from "./useZero";
import { useDossierDataStore } from "@/store/useDossierDataStore";

export function useTransferDossier(
	dossierId: MaybeRefOrGetter<string | undefined>,
) {
	const { data: usersEligibleForTransfer } = useQuery(() =>
		queries.user.availableAsOwner({ dossierId: toValue(dossierId) ?? "" }),
	);

	const z = useZero();
	const newDossierOwnerId = ref<string | undefined>(undefined);
	const dossierStore = useDossierStore();
	const transferSucceeded = ref(false);

	const usersEligibleForTransferOptions = computed(() => {
		const currentOwnerId = dossierStore.selectedDossier?.dossierOwner;
		return usersEligibleForTransfer.value
			?.filter((u) => u.id !== currentOwnerId)
			.map((u) => ({
				label: `${u.fullName} (${u.emailAddress})`,
				value: u.id,
			}));
	});

	async function updateDossierOwner() {
		const id = toValue(dossierId);
		const ownerId = newDossierOwnerId.value;
		if (!id || !ownerId) {
			return;
		}

		if (dossierStore.selectedDossier) {
			await useDossierDataStore().saveImmediate(
				dossierStore.selectedDossier.id,
			);
		}

		const { type } = await z.value.mutate(
			mutators.dossier.setOwner({
				id,
				ownerId,
			}),
		).client;

		if (type === "success") {
			transferSucceeded.value = true;
			newDossierOwnerId.value = undefined;

			setTimeout(() => {
				transferSucceeded.value = false;
			}, 3000);
		}
	}

	return {
		newDossierOwnerId,
		usersEligibleForTransferOptions,
		updateDossierOwner,
		transferSucceeded,
	};
}
